export const ERROR_SOURCES = {
  STORE_PROPERTIES: 'STORE_PROPERTIES'
};
